<template>
	<div class="row sub-sub">

    <div v-if="loading">
      <div class="col-md-12 center">
        <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
      </div>
    </div>

    <div v-else class="col-md-12 center">
      <h4>{{ title }}</h4>
      <input type="text" v-model="filterData" :placeholder=" $t('FILTRO') ">
    </div>
     
    <div class="col-md-3 mt20">
      <ul>
        <li v-for="(item, index) in largeListFiltered" v-if="index < largeListFiltered4th" :key="index">
          <router-link :to="item.link">{{ item.nombre }} <div v-if=" item.num > 0 " class="c-quantity">( {{ item.num }} )</div></router-link>
        </li>
      </ul>        
    </div>
    <div class="col-md-3 mt20">
      <ul>
        <li v-for="(item, index) in largeListFiltered" v-if="index >= largeListFiltered4th && index < (largeListFiltered4th * 2)" :key="index">
          <router-link :to="item.link">{{ item.nombre }} <div v-if=" item.num > 0 " class="c-quantity">( {{ item.num }} )</div></router-link>
        </li>
      </ul>        
    </div>
    <div class="col-md-3 mt20">
      <ul>
        <li v-for="(item, index) in largeListFiltered" v-if="index >= (largeListFiltered4th * 2) && index < (largeListFiltered4th * 3)" :key="index">
          <router-link :to="item.link">{{ item.nombre }} <div v-if=" item.num > 0 " class="c-quantity">( {{ item.num }} )</div></router-link>
        </li>
      </ul>        
    </div>
    <div class="col-md-3 mt20">
      <ul>
        <li v-for="(item, index) in largeListFiltered" v-if="index >= (largeListFiltered4th * 3)" :key="index">
          <router-link :to="item.link">{{ item.nombre }} <div v-if=" item.num > 0 " class="c-quantity">( {{ item.num }} )</div></router-link>
        </li>
      </ul>        
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "FILTRO": "FILTRO"
  },
  "en": {
    "FILTRO": "FILTER"
  },
  "ca": {
    "FILTRO": "FILTRE"
  }
}
</i18n>

<script>
  import axios from 'axios';
  import { mapState, mapGetters } from 'vuex';

  export default {
    data() {
      return {
        title: '',
        menu: {},
        largeList: [],
        filterData: '',
        loading: false,
      }
    },
    mounted(){
      this.cargarLargeList();
    },
    computed: { 
      ...mapGetters(['menuState', 'getPath', 'getLocale', 'getApiUrl'] ),
      largeListFiltered: function(){
        return this.largeList.filter( (item) => {
          return item.nombre.toLowerCase().includes(this.filterData.toLowerCase());
        })
      },
      largeListFilteredLength: function(){
        return Object.keys(this.largeListFiltered).length;
      },
      largeListFiltered4th: function(){
        return Math.ceil(this.largeListFilteredLength / 4);
      }
    },
    methods:{
      cargarLargeList(){
        this.showLoading();
        axios.get(this.getApiUrl + this.getLocale + '/' + this.menuState.categoria + '/' + this.menuState.subCategoria )
          .then( (respuesta) =>{
            /*setTimeout(() => {*/
              this.title = respuesta.data.nombre;
              this.largeList = respuesta.data.subapartados;
              this.hideLoading(); 
           /* },3000);*/
            
          })

      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; }
    },
    watch: {
      menuState: function() { 
        this.largeList = [];
        this.cargarLargeList();
      }
    }
  }
</script>
<style scoped>
  .c-quantity{ 
    display: inline-block; 
    font-weight: 100;
    color: #DDD;
    margin-left: 5px;
  }
</style>
